export const compressImageSmartly = (file) => {

  if (file.size < 500000) return Promise.resolve(file);

  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e) => {
      const img = new Image();
      img.src = e.target.result;
      img.onload = () => {
        const canvas = document.createElement("canvas");
        // Extreme Speed: 600px width par 25 images boht fast upload hongi
        const MAX_WIDTH = 600; 
        const scale = MAX_WIDTH / img.width;
        canvas.width = MAX_WIDTH;
        canvas.height = img.height * scale;

        const ctx = canvas.getContext("2d", { alpha: false });
        ctx.imageSmoothingEnabled = false; // Disable smoothing for extra speed
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

        // Quality 0.4: File size 80-90% reduce ho jayega
        canvas.toBlob((blob) => {
          resolve(new File([blob], file.name, { type: "image/jpeg" }));
        }, "image/jpeg", 0.4); 
      };
    };
  });
};